export default __webpack_public_path__ + "static/media/charger1.c3022b51.png";